export default function () {
    $(document).ready(function () {
        let rm = $('#rain-maker');
        let closeButton = $('#rain-maker').find('#js-rainmaker-close-out');
        let submitCta = rm.find('a.button');
        let closeOut = false;
        let thisClass = 'rainmaker-hidden';
        let skyBoxDom = document.getElementById('scroll_prestitial');
        let skyboxState = 'Collapsed';
        let observer;
        let scrollTopPosition;
        let firstPass = 0;
        let regex = new RegExp('__container__');

        let rmResizeHandle;
        let rmRmScrollHandle;

        let trackingInit = false;

        initRainMakerScroll();

        closeButton.click(function () {
            closeOut = true;
            removeRainMaker();
            stopMutationObservable();
            unsetRainMakerScroll();
            unsetRainMakerResize();
        });

        function unsetRainMakerScroll() {
            if (typeof rmRmScrollHandle !== 'undefined') {
                $(window).off(rmRmScrollHandle);
            }
        }

        function unsetRainMakerResize() {
            if (typeof rmResizeHandle !== 'undefined') {
                $(window).off(rmResizeHandle);
            }
        }

        function initRainMakerScroll() {
            if (rm.length) {
                $(window).scroll(function (handler) {
                    rmRmScrollHandle = handler;
                    scrollTopPosition = $(this).scrollTop();
                    check();
                });
            }
        }

        function initRainMakerResize() {
            $(window).resize(function (handler) {
                rmResizeHandle = handler;
                observer.disconnect();
                clearTimeout(window.resizeEvt);
                window.resizeEvt = setTimeout(function () {
                    initMutationObservable();
                }, 250);
            });
        }

        function removeRainMaker() {
            rm.addClass(thisClass);
        }

        function addRainMaker() {
            rm.removeClass(thisClass);
            if (rm.length && !trackingInit) initRainMakerTracking();
        }

        function initMutationObservable() {
            observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (regex.test($(mutation.target).attr('id'))) {
                        if (mutation.target.offsetHeight < 150) {
                            skyboxState = 'Collapsed';
                        } else {
                            firstPass++;
                            skyboxState = 'Expanded';
                        }

                        if (firstPass > 1) {
                            check();
                        }
                    }
                });
            });

            var config = { attributes: true, subtree: true };
            observer.observe(skyBoxDom, config);
        }

        function check() {
            if (
                skyboxState === 'Collapsed' &&
                scrollTopPosition > 0 &&
                rm.hasClass(thisClass) &&
                closeOut === false
            ) {
                addRainMaker();
            } else if (skyboxState === 'Expanded' || scrollTopPosition === 0 || closeOut === true) {
                removeRainMaker();
            }
        }

        function stopMutationObservable() {
            if (typeof observer !== 'undefined') {
                observer.disconnect();
            }
        }

        function onOmLoad(callback) {
            if (typeof om === 'undefined') {
                setTimeout(() => onOmLoad(callback), 250);
            } else {
                callback();
            }
        }

        function initRainMakerTracking() {
            onOmLoad(function () {
                let showId = CBS.Registry.Show.id ?? '';
                let showTitle = CBS.Registry.Show.name ?? '';
                let showSeriesTitle = `${showId}|${showTitle}`;
                let showGenre =
                    document.getElementById('rain-maker').getAttribute('data-genre') ?? '';
                let trackingObj = {
                    showGenre: showGenre,
                    showId: showId,
                    showTitle: showTitle,
                    showSeriesTitle: showSeriesTitle
                };
                // Tracking for page load
                om.trackAction('trackRainmakerDisplay', trackingObj);

                // Tracking for CTA click event
                submitCta.click((event) => {
                    om.trackAction('trackRainmakerSubmit', trackingObj);
                });

                // Tracking for "cancel" button
                closeButton.click(() => {
                    om.trackAction('trackRainmakerCancel', trackingObj);
                });

                // Sets flag to true
                trackingInit = true;
            });
        }

        /* highight the focus */
        $('#js-rainmaker-close-out').focus(function () {
            $('#rain-maker').removeClass('rainmaker-hidden');
        });

        /* once within focus, turn off div if user press enter */
        $('#js-rainmaker-close-out').keypress(function (e) {
            var key = e.which;
            if (key == 13) {
                // the enter key code
                $(this).addClass('rainmaker-hidden');
                return false;
            }
        });
    });
}
